import BlobImage from 'components/blobImage';
import React from 'react';

export const Leaderboard = ({ data }) => {
    return (
        <div>
            <h2 className="mb10">Leaderboard</h2>
            <div className="prism-content-box">
                <div className="prism-content-hover">
                    {data.map((item, i) => (
                        <div key={`item-${item.id}`} className="flex flex-center">
                            <div className="mr10 text-right" style={{ width: '20px' }}>
                                {i + 1}.
                            </div>
                            <BlobImage
                                folder="avatar"
                                width="25"
                                height="25"
                                initials={item.initials}
                                className="img-circle"
                            />
                            <div className="ml10">{item.full_Name}</div>
                            <div className="flex-grow text-right">{item.value}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Leaderboard;
